import Gradient from "javascript-color-gradient";

const CHART_COLORS = [
  "#00C2FF",
  "#67ADFE",
  "#766EFB",
  "#9D60F2",
  "#EC63D6",
  "#F35991",
  "#EC474C",
  "#FF7144",
  "#FF9F33",
  "#DEDE56",
  "#A1E062",
  "#51D8A5",
];

const DEFAULT_CCOLORS_OUNT = 12;

export const getGradientColors = (colorsCount?: number): string[] => {
  return new Gradient()
    .setColorGradient(...CHART_COLORS)
    .setMidpoint(colorsCount ?? DEFAULT_CCOLORS_OUNT)
    .getColors();
};
